<div class="bg-primary">
  <div class="container">
    <nav class="navbar navbar-expand-lg navbar-dark">
      <a class="navbar-brand" (click)=collapse() [routerLink]="['/kezdolap']">
        <kkk-logo
          [width]="30"
          [height]="30"
          cssClass="d-inline-block align-top"
        >
          <img src="/assets/logo-white-2.png" alt="logo" width="30" height="30" class="d-inline-block align-top"/>
        </kkk-logo>
      </a>
      <button class="navbar-toggler"
              type="button"
              aria-controls="main-menu"
              aria-label="Toggle main navigation"
              [attr.aria-expanded]="ariaExpanded"
              (click)="expanded = !expanded"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" [ngbCollapse]="!expanded" id="main-menu">
        <ul *ngFor="let menu of mainMenu.menus" class="navbar-nav {{menu.cssClass}}">
          <li *ngFor="let menuItem of menu.items"
              class="nav-item"
              [class.has-submenu]="menuItem.submenu"
              [routerLinkActive]="menuItem.submenu ? '': 'active'"
          >
            <a [class]="menuItem.cssClass || 'nav-link'"
               [id]="menuItem.id"
               [routerLink]="menuItem.routerLink"
               (click)="doAction(menuItem, $event)"
            >
              <span *ngIf="menuItem.icon" class="fa fixed-width {{menuItem.icon}}"></span>
              {{ menuItem.label }}
              <span *ngIf="menuItem.submenu" class="fa fa-caret-down"></span>
            </a>
            <ul *ngIf="menuItem.submenu"
                class="submenu bg-primary {{menuItem.submenu.cssClass}}"
                [attr.aria-labelledby]="menuItem.id"
                [class.opened]="menuItem.submenu && menuItem.submenu === mainMenu.openedSubmenu"
            >
              <li *ngFor="let subMenuItem of menuItem.submenu.items"
                  class="nav-item"
                  [class.has-submenu]="subMenuItem.submenu"
                  [routerLinkActive]="subMenuItem.submenu ? '': 'active'"
              >
                <a class="nav-link"
                   [id]="subMenuItem.id"
                   [routerLink]="subMenuItem.routerLink"
                   (click)="doAction(subMenuItem, $event)"
                >
                  <span *ngIf="subMenuItem.icon" class="fa fixed-width {{subMenuItem.icon}}"></span>
                  {{ subMenuItem.label }}
                  <span *ngIf="subMenuItem.submenu" class="fa fa-caret-right pull-right"></span>
                </a>
                <ul *ngIf="subMenuItem.submenu"
                    class="submenu bg-primary {{menuItem.submenu.cssClass}}"
                    [attr.aria-labelledby]="subMenuItem.id"
                    [class.opened]="subMenuItem.submenu && subMenuItem.submenu === mainMenu.openedSubSubmenu"
                >
                  <li *ngFor="let lowerMenuItem of subMenuItem.submenu.items"
                      class="nav-item"
                      routerLinkActive="active"
                  >
                    <a class="nav-link"
                       [id]="lowerMenuItem.id"
                       [routerLink]="lowerMenuItem.routerLink"
                       (click)="doAction(lowerMenuItem, $event)"
                    >
                      <span *ngIf="lowerMenuItem.icon" class="fa fixed-width {{lowerMenuItem.icon}}"></span>
                      {{ lowerMenuItem.label }}
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/main-menu/main-menu.component.html